<template>
  <div>
    <e-charts
      autoresize
      :options="option"
      theme="ovilia-green"
      ref="line"
      auto-resize
    />
  </div>
</template>

<script>
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/chart/sunburst";
import theme from "../graph/theme.json";
ECharts.registerTheme("ovilia-green", theme);

export default {
  components: { ECharts },
  props: ["data"],
  computed: {
    option() {
      let data = this.data.map(d => {
        d.name = this.$t(`Costs.${d.name}`);
        return d;
      });
      return {
        tooltip: {
          formatter: function(e) {
            if (e.data.percentage == null) {
              return `Totaal: &euro;${e.value}`;
            }
            return `${e.name}: &euro;${e.value} (${e.data.percentage}%)`;
          }
        },
        series: {
          type: "sunburst",
          data: data,
          radius: [0, "90%"],
          label: {
            rotate: "radial"
          }
        }
      };
    }
  }
};
</script>

<style></style>
